import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
// import { utils, writeFileXLSX } from 'xlsx';
import "./QuizPage.css";
import backgroundImage from "../images/Background.png";

import leftArrow from "../images/LeftArrow.png"
import rightArrow from "../images/RightArrow.png"

import XRightWhite from "../images/XSagBeyaz.png"
import XLeftWhite from "../images/XSolBeyaz.png"
import { getLanguageBasedImage } from '../languageutil/ImageUtil';
import { getText } from '../languageutil/translations';

function QuizPage({ navigate }) {
  const { quizType, quizFile, sectionName, lastQuestion } = useParams();
  const [quizData, setQuizData] = useState([]);
  const [currentSectionIndex, setCurrentSectionIndex] = useState(0);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [answers, setAnswers] = useState({});
  const [sliderValue, setSliderValue] = useState(3.0);
  const [isFirstBigSection, setIsFirstBigSection] = useState();
  const [isLastBigSection, setIsLastBigSection] = useState();
  const [prevButton, setPrevButton] = useState(null);
  const [nextButton, setNextButton] = useState(null);
  const [prevButtonHover, setPrevButtonHover] = useState(null);
  const [nextButtonHover, setNextButtonHover] = useState(null);
  // const navigate = useNavigate();

  const updateProgress = async (updatedAnswers, updatedTargetValues) => {
    try {
      const sectionNames = {
        "sustainability": ["OPERASYON", "ORGANIZASYON", "STRATEJI", "TEKNOLOJI"],
        "strategy": ["STRATEJİ", "TEKNOLOJİ", "ORGANİZASYON", "OPERASYON"],
        "innovation": ["PROBLEM", "İHTİYAÇ", "FIRSAT", "TEHDİT"],
        "technology": ["OPERASYON", "ORGANIZASYON", "STRATEJI", "TEKNOLOJI"],
        "startup": ["PROBLEM", "İHTİYAÇ", "FIRSAT", "TEHDİT", "STRATEJİ", "TEKNOLOJİ", "ORGANİZASYON", "OPERASYON"]
      };

      const currentQuizSections = sectionNames[quizType];
      const bigSectionIndex = currentQuizSections.indexOf(sectionName);
      const companyName = localStorage.getItem('companyName');


      // First, get the existing progress
      const getResponse = await fetch(`https://corexas-analysis-backend-i1q0.onrender.com/api/progress/${encodeURIComponent(companyName)}`, {
        method: 'GET',
        headers: {
          Authorization: localStorage.getItem('jwt'),
        },
      });

      if (getResponse.ok) {
        const data = await getResponse.json();
        const existingAnswers = data.quizProgress?.[quizType]?.answers || {};

        // Merge existing answers with updated answers
        const mergedAnswers = {
          ...existingAnswers,
          ...updatedAnswers
        };

        // Now send the merged data
        const response = await fetch(`https://corexas-analysis-backend-i1q0.onrender.com/api/progress/${encodeURIComponent(companyName)}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: localStorage.getItem('jwt'),
          },
          body: JSON.stringify({
            quizType,
            answers: mergedAnswers,
            currentBigSectionIndex: bigSectionIndex,
            currentSectionIndex,
            currentQuestionIndex,
            latestVisitedRoute: window.location.pathname,
          }),
        });

        if (!response.ok) {
          console.error('Failed to update progress.');
        }
      }
    } catch (error) {
      console.error('Error updating progress:', error);
    }
  };

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/assets/quizdata/${quizType}/${quizFile}`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => setQuizData(data.sections))
      .catch(error => console.error('Error fetching the quiz file:', error));
  }, [quizType, quizFile]);

  useEffect(() => {
    const fetchProgress = async () => {
      if (quizData.length === 0) {
        return;
      }

      const sectionNames = {
        "sustainability": ["OPERASYON", "ORGANİZASYON", "STRATEJİ", "TEKNOLOJİ"],
        "strategy": ["STRATEJİ", "TEKNOLOJİ", "ORGANİZASYON", "OPERASYON"],
        "innovation": ["PROBLEM", "İHTİYAÇ", "FIRSAT", "TEHDİT"],
        "technology": ["OPERASYON", "ORGANİZASYON", "STRATEJİ", "TEKNOLOJİ"],
        "startup": ["PROBLEM", "İHTİYAÇ", "FIRSAT", "TEHDİT", "STRATEJİ", "TEKNOLOJİ", "ORGANİZASYON", "OPERASYON"]
      };

      const currentQuizSections = sectionNames[quizType];
      const bigSectionIndex = currentQuizSections.indexOf(sectionName);
      const companyName = localStorage.getItem('companyName');

      if (!companyName) {
        alert('No company name found. Redirecting to login. Currently intro but will be changed.');
        navigate('/intro');
        return;
      }

      try {
        const response = await fetch(`https://corexas-analysis-backend-i1q0.onrender.com/api/progress/${encodeURIComponent(companyName)}`, {
          method: 'GET',
          headers: {
            Authorization: localStorage.getItem('jwt'),
          },
        });

        if (response.ok) {
          const data = await response.json();
          const quizProgressData = data.quizProgress && data.quizProgress[quizType] ? data.quizProgress[quizType] : {};

          // Keep existing answers and only update indices
          setAnswers(prevAnswers => ({
            ...prevAnswers,
            ...quizProgressData.answers
          }));

          if (lastQuestion !== 'last') {
            const isSameBigSection = data.quizProgress[quizType]?.currentBigSectionIndex === bigSectionIndex;
            const sectionIndex = isSameBigSection ? data.quizProgress[quizType]?.currentSectionIndex : 0;
            const questionIndex = isSameBigSection ? data.quizProgress[quizType]?.currentQuestionIndex : 0;

            const validSectionIndex = Math.min(Math.max(sectionIndex, 0), quizData.length - 1);
            setCurrentSectionIndex(validSectionIndex);

            const sectionQuestions = quizData[validSectionIndex]?.questions || [];
            const validQuestionIndex = Math.min(Math.max(questionIndex, 0), sectionQuestions.length - 1);
            setCurrentQuestionIndex(validQuestionIndex);
          }
        } else {
          if (response.status === 404) {
            alert('Company not found. Redirecting to login.');
            navigate('/intro');
          } else if (response.status === 401) {
            alert('Unauthorized. Redirecting to login.');
            navigate('/');
          } else {
            alert('Failed to fetch progress.');
          }
        }
      } catch (error) {
        console.error('Error fetching progress:', error);
        alert('Error fetching progress. Please try again later.');
      }
    }

    fetchProgress();
  }, [navigate, quizType, sectionName, quizData, lastQuestion]);

  const currentSection = quizData[currentSectionIndex];
  const currentQuestion = currentSection?.questions[currentQuestionIndex];

  const handleChange = (value) => {
    const questionKey = encodeKey(currentQuestion.question);
    const updatedAnswers = {
      ...answers,
      [questionKey]: {
        ...answers[questionKey],
        value: value,
        bigSection: sectionName,
        section: currentSection.name,
        questionNumber: currentQuestionIndex + 1
      }
    };
    setAnswers(updatedAnswers);
    setSliderValue(parseFloat(value)); // Add this line to update slider value
    localStorage.setItem('quizAnswers', JSON.stringify(updatedAnswers));
    updateProgress(updatedAnswers);
  };

  useEffect(() => {
    document.documentElement.style.setProperty('--range-value', (sliderValue * 10 - 10) / 40 * 85 + 8 + '%');
    console.log("Current Slider Value:", sliderValue);
  }, [sliderValue])


  const handleTargetChange = (value) => {
    // Remove all characters except numbers and dot
    const sanitizedValue = value.replace(/[^\d.]/g, '');

    // Ensure only one decimal point
    const parts = sanitizedValue.split('.');
    let formattedValue = parts[0] || '';
    if (parts.length > 1) {
      formattedValue += '.' + parts[1].slice(0, 1);
    }

    // Convert to number for validation
    const numValue = parseFloat(formattedValue);

    // Validate range between 1 and 5
    if (!isNaN(numValue) && numValue >= 1 && numValue <= 5) {
      const questionKey = encodeKey(currentQuestion.question);
      const updatedAnswers = {
        ...answers,
        [questionKey]: {
          ...answers[questionKey],
          targetValue: formattedValue,
          bigSection: sectionName,
          section: currentSection.name,
          questionNumber: currentQuestionIndex + 1
        }
      };
      setAnswers(updatedAnswers);
      localStorage.setItem('quizAnswers', JSON.stringify(updatedAnswers));
      updateProgress(updatedAnswers);
    } else if (formattedValue === '' || formattedValue === '.') {
      // Allow empty input or single dot while typing
      const updatedAnswers = {
        ...answers,
        [encodeKey(currentQuestion?.question)]: {
          ...answers[encodeKey(currentQuestion?.question)],
          targetValue: formattedValue
        }
      };
      setAnswers(updatedAnswers);
    }
  };


  const handleNext = () => {
    if (currentQuestionIndex < currentSection.questions.length - 1) {
      setCurrentQuestionIndex(prevIndex => {
        const nextIndex = prevIndex + 1;
        // setSliderValue(answers[quizData[currentSectionIndex]?.questions[nextIndex].question] || 3.0); // Reset slider value
        return nextIndex;
      });
    } else if (currentSectionIndex < quizData.length - 1) {
      setCurrentSectionIndex(prevIndex => {
        const nextSectionIndex = prevIndex + 1;
        setCurrentQuestionIndex(0);
        // setSliderValue(answers[quizData[nextSectionIndex]?.questions[0].question] || 3.0); // Reset slider value
        return nextSectionIndex;
      });
    }
    updateProgress(answers, currentSectionIndex, currentQuestionIndex);
  };

  const handlePreviousBigSection = () => {
    console.log("Handling previous big section navigation");
    const sectionNames = {
      "sustainability": ["OPERASYON", "ORGANİZASYON", "STRATEJİ", "TEKNOLOJİ"],
      "strategy": ["STRATEJİ", "TEKNOLOJİ", "ORGANİZASYON", "OPERASYON"],
      "innovation": ["PROBLEM", "İHTİYAÇ", "FIRSAT", "TEHDİT"],
      "technology": ["OPERASYON", "ORGANİZASYON", "STRATEJİ", "TEKNOLOJİ"],
      "startup": ["PROBLEM", "İHTİYAÇ", "FIRSAT", "TEHDİT", "STRATEJİ", "TEKNOLOJİ", "ORGANİZASYON", "OPERASYON"]
    };

    const jsonFileNames = {
      "sustainability": ["OperasyonAnaBoyut.json", "OrganizasyonAnaBoyut.json", "StratejiAnaBoyut.json", "TeknolojiAnaBoyut.json"],
      "strategy": ["StratejiAnaBoyut.json", "TeknolojiAnaBoyut.json", "OrganizasyonAnaBoyut.json", "OperasyonAnaBoyut.json"],
      "innovation": ["ProblemAnaBoyut.json", "IhtiyacAnaBoyut.json", "FirsatAnaBoyut.json", "TehditAnaBoyut.json"],
      "technology": ["OperasyonAnaBoyut.json", "OrganizasyonAnaBoyut.json", "StratejiAnaBoyut.json", "TeknolojiAnaBoyut.json"],
      "startup": ["ProblemAnaBoyut.json", "IhtiyacAnaBoyut.json", "FirsatAnaBoyut.json", "TehditAnaBoyut.json", "StratejiAnaBoyut.json", "TeknolojiAnaBoyut.json", "OrganizasyonAnaBoyut.json", "OperasyonAnaBoyut.json"]
    };

    const currentQuizSections = sectionNames[quizType];
    const sectionIndex = currentQuizSections.indexOf(sectionName);
    console.log("Current section index:", sectionIndex);

    if (sectionIndex > 0) {
      // Fetch the previous section's data to get its last question index
      fetch(`${process.env.PUBLIC_URL}/assets/quizdata/${quizType}/${jsonFileNames[quizType][sectionIndex - 1]}`)
        .then(response => response.json())
        .then(data => {
          const lastQuestionIndex = data.sections[data.sections.length - 1].questions.length - 1;
          console.log("Navigating to previous section with last question index:", lastQuestionIndex);

          navigate(
            `/quiz/${quizType}/${jsonFileNames[quizType][sectionIndex - 1]}/${currentQuizSections[sectionIndex - 1]}/last`
          );
        })
        .catch(error => console.error('Error fetching the previous section:', error));
    }
  };

  useEffect(() => {
    if (lastQuestion === 'last' && quizData.length > 0) {
      // Set to the last section
      const lastSectionIndex = quizData.length - 1;
      setCurrentSectionIndex(lastSectionIndex);

      // Get the last question index of the last section
      const lastSection = quizData[lastSectionIndex];
      const lastQuestionIndex = lastSection.questions.length - 1;

      // Set to the last question
      console.log("Setting to last question index:", lastQuestionIndex);
      setCurrentQuestionIndex(lastQuestionIndex);
    }
  }, [lastQuestion, quizData]);

  const handlePrevious = () => {
    console.log("Handling previous navigation");
    console.log("Current section:", currentSectionIndex, "Current question:", currentQuestionIndex);

    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex(prevIndex => {
        const prevQuestionIndex = prevIndex - 1;
        setSliderValue(answers[quizData[currentSectionIndex]?.questions[prevQuestionIndex].question] || 3.0);
        updateProgress(answers, currentSectionIndex, currentQuestionIndex);
        return prevQuestionIndex;
      });
    } else if (currentSectionIndex > 0) {
      setCurrentSectionIndex(prevIndex => {
        const prevSectionIndex = prevIndex - 1;
        const lastQuestionIndex = quizData[prevSectionIndex].questions.length - 1;
        setCurrentQuestionIndex(lastQuestionIndex);
        setSliderValue(answers[quizData[prevSectionIndex]?.questions[lastQuestionIndex].question] || 3.0);
        updateProgress(answers, currentSectionIndex, currentQuestionIndex);
        return prevSectionIndex;
      });
    } else if (!isFirstBigSection) {
      console.log("At first question of first section, going to previous big section");
      handlePreviousBigSection();
    }
  };

  const handleJumpToNextSection = () => {
    console.log("Jumping to next section");
    if (currentSectionIndex < quizData.length - 1) {
      setCurrentSectionIndex(prevIndex => {
        const nextSectionIndex = prevIndex + 1;
        setCurrentQuestionIndex(0);
        setSliderValue(answers[quizData[nextSectionIndex]?.questions[0].question] || 3.0); // Reset slider value
        return nextSectionIndex;
      });
    } else {
      handleSave();
    }
  };

  const handleJumpToPreviousSection = () => {
    if (currentSectionIndex > 0) {
      setCurrentSectionIndex(prevIndex => {
        const prevSectionIndex = prevIndex - 1;
        setCurrentQuestionIndex(0);
        setSliderValue(answers[quizData[prevSectionIndex]?.questions[0].question] || 3.0); // Reset slider value
        return prevSectionIndex;
      });
    } else {
      handlePreviousBigSection();
    }
  };

  const handleSave = async () => {
    console.log("here");
    let route;
    // if (quizType === "sustainability") {
    //   if (sectionName === "OPERASYON")
    //     route = '/quiz/sustainability/OrganizasyonAnaBoyut.json/ORGANIZASYON';
    //   else if (sectionName === "ORGANIZASYON")
    //     route = '/quiz/sustainability/StratejiAnaBoyut.json/STRATEJI';
    //   else if (sectionName === "STRATEJI")
    //     route = '/quiz/sustainability/TeknolojiAnaBoyut.json/TEKNOLOJI';
    //   else if (sectionName === "TEKNOLOJI") {
    //     route = '/selectquiz';
    //     // route = '/quizstart/strategy';
    //   }
    // } else if (quizType === "strategy") {
    //   if (sectionName === "STRATEJİ")
    //     route = '/quiz/strategy/TeknolojiAnaBoyut.json/TEKNOLOJİ';
    //   else if (sectionName === "TEKNOLOJİ")
    //     route = '/quiz/strategy/OrganizasyonAnaBoyut.json/ORGANİZASYON';
    //   else if (sectionName === "ORGANİZASYON")
    //     route = '/quiz/strategy/OperasyonAnaBoyut.json/OPERASYON';
    //   else if (sectionName === "OPERASYON")
    //     route = '/selectquiz';
    //   // route = '/results';
    // } else if (quizType === "innovation") {
    //   if (sectionName === "PROBLEM")
    //     route = '/quiz/innovation/IhtiyacAnaBoyut.json/İHTİYAÇ';
    //   else if (sectionName === "İHTİYAÇ")
    //     route = '/quiz/innovation/FirsatAnaBoyut.json/FIRSAT';
    //   else if (sectionName === "FIRSAT")
    //     route = '/quiz/innovation/TehditAnaBoyut.json/TEHDİT';
    //   else if (sectionName === "TEHDİT")
    //     //   route = '/quiz/innovation/StratejiAnaBoyut.json/STRATEJİ';
    //     // else if (sectionName === "STRATEJİ")
    //     //   route = '/quiz/innovation/TeknolojiAnaBoyut.json/TEKNOLOJİ';
    //     // else if (sectionName === "TEKNOLOJİ")
    //     //   route = '/quiz/innovation/OrganizasyonAnaBoyut.json/ORGANİZASYON';
    //     route = '/selectquiz';
    //   // route = '/quizstart/technology';
    // } else if (quizType === "technology") {
    //   if (sectionName === "OPERASYON")
    //     route = '/quiz/technology/OrganizasyonAnaBoyut.json/ORGANİZASYON';
    //   else if (sectionName === "ORGANİZASYON")
    //     route = '/quiz/technology/StratejiAnaBoyut.json/STRATEJİ';
    //   else if (sectionName === "STRATEJİ")
    //     route = '/quiz/technology/TeknolojiAnaBoyut.json/TEKNOLOJİ';
    //   else if (sectionName === "TEKNOLOJİ")
    //     route = '/selectquiz';
    //   // route = '/quizstart/sustainability';
    // } else 
    if (quizType === "startup") {
      if (sectionName === "PROBLEM")
        route = '/quiz/startup/IhtiyacAnaBoyut.json/İHTİYAÇ';
      else if (sectionName === "İHTİYAÇ")
        route = '/quiz/startup/FirsatAnaBoyut.json/FIRSAT';
      else if (sectionName === "FIRSAT")
        route = '/quiz/startup/TehditAnaBoyut.json/TEHDİT';
      else if (sectionName === "TEHDİT")
        route = '/quiz/startup/StratejiAnaBoyut.json/STRATEJİ';
      else if (sectionName === "STRATEJİ")
        route = '/quiz/startup/TeknolojiAnaBoyut.json/TEKNOLOJİ';
      else if (sectionName === "TEKNOLOJİ")
        route = '/quiz/startup/OrganizasyonAnaBoyut.json/ORGANİZASYON';
      else if (sectionName === "ORGANİZASYON")
        route = '/quiz/startup/OperasyonAnaBoyut.json/OPERASYON';
      else if (sectionName === "OPERASYON")
        route = '/intro';
    }

    const companyName = localStorage.getItem('companyName');
    try {
      // First get existing progress
      const getResponse = await fetch(`https://corexas-analysis-backend-i1q0.onrender.com/api/progress/${encodeURIComponent(companyName)}`, {
        method: 'GET',
        headers: {
          Authorization: localStorage.getItem('jwt'),
        },
      });

      if (getResponse.ok) {
        const data = await getResponse.json();
        const existingAnswers = data.quizProgress?.[quizType]?.answers || {};

        // Merge existing answers with current answers
        const mergedAnswers = {
          ...existingAnswers,
          ...answers
        };

        const response = await fetch(`https://corexas-analysis-backend-i1q0.onrender.com/api/progress/${encodeURIComponent(companyName)}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: localStorage.getItem('jwt'),
          },
          body: JSON.stringify({
            latestVisitedRoute: route,
            quizType: quizType,
            answers: mergedAnswers
          }),
        });
        if (!response.ok) {
          console.error('Failed to update progress.');
        }
      }
    } catch (error) {
      console.error('Error updating progress:', error);
    }

    navigate(route);
  };

  useEffect(() => {
    const sectionNames = {
      "sustainability": ["OPERASYON", "ORGANİZASYON", "STRATEJİ", "TEKNOLOJİ"],
      "strategy": ["STRATEJİ", "TEKNOLOJİ", "ORGANİZASYON", "OPERASYON"],
      "innovation": ["PROBLEM", "İHTİYAÇ", "FIRSAT", "TEHDİT", "STRATEJİ", "TEKNOLOJİ", "ORGANİZASYON"],
      "technology": ["OPERASYON", "ORGANİZASYON", "STRATEJİ", "TEKNOLOJİ"],
      "startup": ["PROBLEM", "İHTİYAÇ", "FIRSAT", "TEHDİT", "STRATEJİ", "TEKNOLOJİ", "ORGANİZASYON", "OPERASYON"]
    };

    const currentQuizSections = sectionNames[quizType];

    const bigSectionIndex = currentQuizSections.indexOf(sectionName);

    // console.log(bigSectionIndex > 0);
    if (bigSectionIndex > 0) {
      setIsFirstBigSection(false);
    } else setIsFirstBigSection(true);

    if (bigSectionIndex < 3) {
      setIsLastBigSection(false);
    } else {
      setIsLastBigSection(true);
    }
  }, [quizType, sectionName])

  const encodeKey = (key) => {
    return key?.replace(/ /g, '_').replace(/\./g, '_dot_');
  };

  // useEffect(() => {
  //   if (Object.keys(answers).length === 0) return;
  //   if (currentQuestion) {
  //     const encodedKey = encodeKey(currentQuestion.question);
  //     console.log("Current Question: " + currentQuestion.question);
  //     console.log("Encoded Key: " + encodedKey);
  //     console.log("Current Answer: " + answers[encodedKey]);
  //     console.log("Answers: " + JSON.stringify(answers));
  //     setSliderValue(answers[encodedKey] || 30);
  //   }
  // }, [currentQuestionIndex, currentSectionIndex, answers, currentQuestion, sliderValue]);

  useEffect(() => {
    if (Object.keys(answers).length === 0) return; // Skip if no answers
    if (currentQuestion) {
      const encodedKey = encodeKey(currentQuestion.question); // Encode the key
      const currentValue = answers[encodedKey]?.value || 3.0; // Change this line to access value property
      setSliderValue(parseFloat(currentValue)); // Add parseFloat here
    }
  }, [currentQuestionIndex, currentSectionIndex, answers, currentQuestion]); // Remove `sliderValue` from dependencies

  // useEffect(() => {
  //   if (Object.keys(answers).length === 0) return;
  //   if (currentQuestion) {
  //     console.log("Current Question: " + currentQuestion.question);
  //     console.log("Current Answer: " + answers[currentQuestion.question]);
  //     console.log("Answers: " + JSON.stringify(answers));
  //     setSliderValue(answers[currentQuestion.question] || 30);
  //   }
  // }, [currentQuestionIndex, currentSectionIndex, currentQuestion, answers]);

  const getVisibleSections = () => {
    if (quizData.length === 0) return [null, null, null];

    const left = currentSectionIndex > 0 ? quizData[currentSectionIndex - 1] : null;
    const middle = quizData[currentSectionIndex];
    const right = currentSectionIndex < quizData.length - 1 ? quizData[currentSectionIndex + 1] : null;

    return [left, middle, right];
  };

  useEffect(() => {
    if (quizData.length > 0) {
      if (currentSectionIndex >= quizData.length) {
        setCurrentSectionIndex(quizData.length - 1);
      }
      if (currentSectionIndex < 0) {
        setCurrentSectionIndex(0);
      }
      const sectionQuestions = quizData[currentSectionIndex]?.questions || [];
      if (currentQuestionIndex >= sectionQuestions.length) {
        setCurrentQuestionIndex(sectionQuestions.length - 1);
      }
      if (currentQuestionIndex < 0) {
        setCurrentQuestionIndex(0);
      }
    }
  }, [quizData, currentSectionIndex, currentQuestionIndex]);

  useEffect(() => {
    // Only reset indices if lastQuestion is not 'last'
    if (!lastQuestion && quizData.length > 0) {
      const shouldResetIndices = window.location.pathname.indexOf('/last') === -1;
      if (shouldResetIndices) {
        setCurrentSectionIndex(0);
        setCurrentQuestionIndex(0);
      }
    }
  }, [quizType, quizFile, sectionName, lastQuestion, quizData]);

  useEffect(() => {
    const goToLastQuestion = () => {
      if (quizData.length > 0) {
        // Set to the last section
        const lastSectionIndex = quizData.length - 1;
        setCurrentSectionIndex(lastSectionIndex);

        // Get the last question index of the last section
        const lastSection = quizData[lastSectionIndex];
        const lastQuestionIndex = lastSection.questions.length - 1;

        // Set to the last question
        console.log("Setting to last question index:", lastQuestionIndex);
        setCurrentQuestionIndex(lastQuestionIndex);
      }
    };

    if (lastQuestion === 'last' || window.location.pathname.indexOf('/last') !== -1) {
      goToLastQuestion();
    }
  }, [lastQuestion, quizData]);

  const visibleSections = getVisibleSections();

  // useEffect(() => {
  //   const location = window.location;
  //   if (location.state?.goToLastQuestion) {
  //     // Set the section to the last section
  //     setCurrentSectionIndex(quizData.length - 1);
  //     // Set the question to the last question
  //     setCurrentQuestionIndex(location.state.lastQuestionIndex);
  //     // Clear the navigation state
  //     window.history.replaceState({}, document.title);
  //   }
  // }, [quizData]);

  useEffect(() => {
    setPrevButton(getLanguageBasedImage('PreviousQuestion.png'));
    setNextButton(getLanguageBasedImage('NextQuestion.png'));
    setPrevButtonHover(getLanguageBasedImage('PreviousQuestionHover.png'));
    setNextButtonHover(getLanguageBasedImage('NextQuestionHover.png'));
  }, []);

  return (
    <div className={"quiz-page"} style={{ overflow: "hidden", paddingLeft: "20px", paddingRight: "20px", width: "calc(100vw - 40px)", height: "100vh", backgroundImage: `url(${backgroundImage})`, backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center", alignContent: "center" }}>
      <div style={{ maxWidth: "1442px", maxHeight: "691px", justifySelf: "center" }}>
        {quizData.length > 0 && (
          <div className='quiz-page-header'>
            <div style={{ display: "flex", flexDirection: "row", height: "15vh", width: "100vw", maxWidth: "1442px", maxHeight: "105px" }}>
              <div className='quiz-page-header-left-section'>
                <div className="TextDiv" style={{ width: "calc(100% - 20px)", height: "40%", display: "flex", alignItems: "center", justifyContent: "space-between", paddingLeft: "10px" }}>
                  <img alt="" src={XLeftWhite} style={{ width: "30px", aspectRatio: 1, cursor: "pointer" }} onClick={() => { navigate("/intro"); }} />
                  <p style={{ margin: 0, fontWeight: "bold", fontSize: 30 }}> {sectionName} </p>
                  <img alt="" src={XRightWhite} style={{ width: "30px", aspectRatio: 1, cursor: "pointer" }} onClick={() => { navigate("/intro"); }} />
                </div>
                <div className='linear-gradient' style={{ width: "100%", height: "3px" }} />
                <div style={{ display: "flex", flexDirection: "row", height: "60%", justifyContent: "space-between" }}>
                  {!(currentSectionIndex === 0 && isFirstBigSection) &&
                    <img src={leftArrow} alt={""} onClick={handleJumpToPreviousSection} style={{ cursor: "pointer", aspectRatio: 1, height: "70%", alignSelf: "center" }} />}
                  {/* <button onClick={handleJumpToPreviousSection} style={{ width: "10%", height: "100%" }}>Previous Section</button>} */}
                  {(currentSectionIndex === 0 && isFirstBigSection) &&
                    <div style={{ width: "10%", height: "100%" }} />}

                  <div
                    className="section-names-container"
                    style={{ display: "flex", justifyContent: "space-between", width: "100%" }}
                  >
                    {visibleSections.map((section, index) => {
                      const isActive = quizData.indexOf(section) === currentSectionIndex;

                      return section ? (
                        <p
                          key={`section-${index}`}
                          className={`section-name ${isActive ? 'active-section' : 'inactive-section'}`}
                          onClick={() => {
                            setCurrentSectionIndex(quizData.indexOf(section));
                            setCurrentQuestionIndex(0);
                          }}
                          style={{ flex: 1, textAlign: 'center', cursor: 'pointer', fontSize: "16px" }}
                        >
                          {section.name}
                        </p>
                      ) : (
                        <div key={`spacer-${index}`} style={{ flex: 1 }} />
                      );
                    })}
                  </div>
                  {!(currentSectionIndex === quizData.length - 1 && currentQuestionIndex === currentSection.questions.length - 1 && isLastBigSection) &&
                    <img src={rightArrow} alt='' onClick={handleJumpToNextSection} style={{ cursor: "pointer", aspectRatio: 1, height: "70%", alignSelf: "center" }} />}
                  {(currentSectionIndex === quizData.length - 1 && currentQuestionIndex === currentSection.questions.length - 1 && isLastBigSection) &&
                    <div style={{ width: "10%", height: "100%" }} />}
                </div>
              </div>
              <div className='quiz-page-header-right-section center-items' style={{ borderImage: 'linear-gradient(to right, #001039, #02315d, #359fd3, #c4eef6, #fefffe, #fefffe, #c4eef6,  #359fd3, #02315d, #001039) 1', borderColor: "#63a3cb", borderWidth: "1px", borderStyle: "solid", width: "15%" }}> {/* WILL BE CHECKED LATER FOR SHAPE ERRORS */}
              <div className="circle linear-gradient-rotated center-items" style={{
                    position: 'relative',
                    height: "90%",
                    aspectRatio: 1,
                    background: 'linear-gradient(to right, #001039, #02315d, #359fd3, #c4eef6, #fefffe, #fefffe, #c4eef6, #359fd3, #02315d, #001039)',
                    borderRadius: '50%',
                    padding: '2px'
                  }}>
                <div className="circle linear-gradient-rotated center-items" style={{
                  position: 'relative',
                  height: "97%",
                  aspectRatio: 1,
                  background: 'linear-gradient(to bottom, #001039, #02315d, #359fd3, #c4eef6, #fefffe, #fefffe, #c4eef6, #359fd3, #02315d, #001039)',
                  borderRadius: '50%',
                  padding: '2px'
                }}>
                  <div className="circle linear-gradient-rotated center-items" style={{
                    position: 'relative',
                    height: "62%",
                    aspectRatio: 1,
                    background: 'linear-gradient(to right, #001039, #02315d, #359fd3, #c4eef6, #fefffe, #fefffe, #c4eef6, #359fd3, #02315d, #001039)',
                    borderRadius: '50%',
                    padding: '2px'
                  }}>
                    <div className="circle center-items" style={{
                      height: "100%",
                      width: "100%",
                      backgroundColor: "white",
                      borderRadius: '50%',
                      position: "relative"
                    }}>
                      <p style={{ position: "absolute", top: "-10%", fontSize: 12, fontWeight: "bold" }}>{getText('target')}</p>
                      <input
                        style={{
                          position: "absolute",
                          height: "50%",
                          paddingTop: "20%",
                          background: "transparent",
                          border: "none",
                          textAlign: "center",
                          fontWeight: "bold",
                          fontSize: 20,
                          color: "#110e3e"
                        }}
                        type="text"
                        inputMode="decimal"
                        pattern="[0-9]*[.]?[0-9]?"
                        value={answers[encodeKey(currentQuestion?.question)]?.targetValue || ''}
                        onChange={(e) => handleTargetChange(e.target.value)}
                        onBlur={(e) => {
                          const value = e.target.value;
                          if (value === '' || value === '.') {
                            // Reset to empty if invalid on blur
                            const updatedAnswers = {
                              ...answers,
                              [encodeKey(currentQuestion?.question)]: {
                                ...answers[encodeKey(currentQuestion?.question)],
                                targetValue: ''
                              }
                            };
                            setAnswers(updatedAnswers);
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>
          </div>
        )
        }
        {
          quizData.length > 0 && (
            <div style={{ backgroundColor: "white", height: "calc(85vh - 20px - 13px - 20px - 10px)", marginTop: "15px", paddingTop: "10px", maxHeight: "560px" }}>
              <div style={{ height: "20px", width: "100%" }} />
              <div className="question">
                <div className="runnable-range-outer-div" style={{ position: "relative", left: "-80px", top: "234px", width: "25%", display: "flex", justifyContent: "center", alignItems: "center", maxWidth: "374px" }}>
                  <input
                    style={{ rotate: "-90deg", height: "100%" }}
                    type="range"
                    id="range"
                    min="1.0"
                    max="5.0"
                    step="0.1"
                    value={answers[encodeKey(currentQuestion?.question)]?.value || 3.0}
                    onChange={(e) => handleChange(e.target.value)}
                  />
                  <span style={{
                    position: 'absolute',
                    // bottom: `${(sliderValue - 25) / 0.85 - 4.5}vh`,
                    bottom: `${((parseFloat(sliderValue) - 3) * 183 + 25)}%`,
                    // transform: 'translate(-50%, -100%)',
                    backgroundColor: 'transparent',
                    color: '#110e3e',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontSize: '12px',
                    pointerEvents: "none",
                    fontWeight: "bold"
                  }}>
                    {(parseFloat(sliderValue)).toFixed(1)}
                  </span>
                </div>
                <h3 style={{ paddingLeft: "2.5%", marginTop: "-40px" }}>{currentQuestion?.question}</h3>
              </div>
              <div style={{ width: "100%", height: "2px", justifyContent: "center", display: "flex" }}>
                <div className='linear-gradient' style={{ width: "95%", height: "2px" }} />
              </div>

              <div className="answers-container" style={{ paddingLeft: "150px", paddingTop: "40px", height: "50vh", maxHeight: "352px", display: "flex", flexDirection: "column", justifyContent: "space-between", width: "50vw", maxWidth: "800px" }}>
                {currentQuestion?.answers.map((answer, index) => (
                  <div key={index} className="answer" style={{ height: "40px" }}>
                    {index === 4 && <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}> <div style={{ width: "40px", marginRight: "20px", height: "4px", backgroundColor: "#eafcff" }} /> <strong>{getText('nonExistent')}</strong> </div>}
                    {index === 3 && <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}> <div style={{ width: "40px", marginRight: "20px", height: "4px", backgroundColor: "#c4eff7" }} /> <strong>{getText('firstStage')}</strong> </div>}
                    {index === 2 && <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}> <div style={{ width: "40px", marginRight: "20px", height: "4px", backgroundColor: "#6e9cb3" }} /> <strong>{getText('developing')}</strong> </div>}
                    {index === 1 && <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}> <div style={{ width: "40px", marginRight: "20px", height: "4px", backgroundColor: "#043754" }} /> <strong>{getText('mature')}</strong> </div>}
                    {index === 0 && <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}> <div style={{ width: "40px", marginRight: "20px", height: "4px", backgroundColor: "#110e3e" }} /> <strong>{getText('advanced')}</strong> </div>}
                    {/* <br /> */}
                    <div style={{ paddingLeft: "60px" }} >{answer} </div>
                  </div>
                ))}
              </div>


              <div className="navigation" style={{ width: "30%", position: "relative", display: "flex", justifyContent: "space-between", left: "calc(70% - 30px)", bottom: "20px" }}>
                {(!(currentSectionIndex === 0 && currentQuestionIndex === 0) || !isFirstBigSection) && <img alt="" src={prevButton} style={{ width: "129px", height: "41px", cursor: "pointer" }} onMouseOver={e => (e.currentTarget.src = prevButtonHover)} onMouseOut={e => (e.currentTarget.src = prevButton)} onClick={handlePrevious} />}
                {(currentSectionIndex === 0 && currentQuestionIndex === 0) && <div style={{ width: "129px", height: "41px" }} />}
                {!(currentSectionIndex === quizData.length - 1 && currentQuestionIndex === currentSection.questions.length - 1) && <img alt="" src={nextButton} style={{ width: "129px", height: "41px", cursor: "pointer" }} onMouseOver={e => (e.currentTarget.src = nextButtonHover)} onMouseOut={e => (e.currentTarget.src = nextButton)} onClick={handleNext} />}
                {(currentSectionIndex === quizData.length - 1 && currentQuestionIndex === currentSection.questions.length - 1) && <img alt="" src={nextButton} style={{ width: "129px", height: "41px", cursor: "pointer" }} onMouseOver={e => (e.currentTarget.src = nextButtonHover)} onMouseOut={e => (e.currentTarget.src = nextButton)} onClick={handleSave} />}
              </div>
            </div>
          )
        }
      </div>
    </div >
  );
}

export default QuizPage;